import clsx from 'clsx';

type LoadingDotsProps = {
  className?: string;
  variant?: 'DEFAULT' | 'INLINE';
};

export const LoadingDots = ({
  className,
  variant = 'DEFAULT',
}: LoadingDotsProps) => {
  return (
    <div
      className={clsx(
        'flex flex-row',
        {
          'items-center justify-center': variant === 'DEFAULT',
        },
        className,
      )}
    >
      <div className="bg-primary-700 animation-delay-100 m-1 h-1 w-1 animate-ping rounded-full " />
      <div className="bg-primary-700 animation-delay-200 m-1 h-1 w-1 animate-ping rounded-full " />
      <div className="bg-primary-700 animation-delay-300 m-1 h-1 w-1 animate-ping rounded-full " />
    </div>
  );
};
